///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { forEach, groupBy, sumBy, uniq } from "lodash";

import messages from "./messages";
import { round } from "./laneCalculations";

export const groupLoadsByLane = loads => {
  const data = [];
  const groupedByOriginAndDest = groupBy(
    loads,
    l => l.originCityId + "-" + l.destinationCityId
  );

  forEach(groupedByOriginAndDest, groupedData => {
    let loadIds = [];
    let carrierIds = [];
    const sumOfCost = sumBy(groupedData, "cost");
    const sumOfMiles = sumBy(groupedData, l => l.miles || 1);

    groupedData.forEach(x => {
      loadIds.push(x.loadId);
      carrierIds.push(x.carrierId);
    });

    data.push({
      originCity: groupedData[0].originCityName,
      originState: groupedData[0].originStateCode,
      destinationCity: groupedData[0].destinationCityName,
      destinationState: groupedData[0].destinationStateCode,
      volume: groupedData.length,
      carriers: uniq(carrierIds).length,
      cost: round(sumOfCost / groupedData.length),
      cpm: round(sumOfCost / sumOfMiles),
      distance: round(sumBy(groupedData, l => l.miles) / groupedData.length),
      margin: round(sumBy(groupedData, "margin") / groupedData.length),
      rate: round(sumBy(groupedData, "rate") / groupedData.length),
      loadIds,
      carrierIds,
      exclude: messages.exclude.defaultMessage,
      metaData: { matched: true }
    });

    data.map((x, index) => (x.metaData.defaultIndex = index));
  });

  return data;
};

export default groupLoadsByLane;
